import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { Monitor, Moon, Sun } from "Shared/appIcons";
import { Theme, useTheme } from "Shared/Hooks/useTheme";
import { SimpleTooltip } from "Shared/SimpleTooltip";
import { Button } from "@/components/ui/button";

export const ThemeToggle = () => {
	const { t } = useResource();
	const { theme, cycleTheme } = useTheme();

	const label =
		theme === Theme.Light
			? t(Resources.Theme.Light)
			: theme === Theme.Dark
				? t(Resources.Theme.Dark)
				: t(Resources.Theme.System);

	const Icon =
		theme === Theme.Light ? Sun : theme === Theme.Dark ? Moon : Monitor;

	return (
		<SimpleTooltip content={`${t(Resources.Theme.Toggle)} — ${label}`}>
			<Button
				variant="ghost"
				size="icon-sm"
				onClick={cycleTheme}
				className="text-muted-foreground hover:text-foreground rounded-full"
				aria-label={`${t(Resources.Theme.Toggle)} — ${label}`}
			>
				<Icon className="h-4 w-4" />
			</Button>
		</SimpleTooltip>
	);
};
